import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const pillGreen = '#E6F4EA';
const pillGreenText = '#1E4620';
const tealAccent = '#00838F';
const editIconColor = '#1E293B';
export const useBillAutomationExtractedStyles = makeStyles({
  wrapper: {
    marginBottom: '16px',
    padding: 0
  },
  fileStrip: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '8px',
    padding: '12px 14px',
    marginBottom: '12px',
    borderRadius: '6px',
    backgroundColor: palette.common.white,
    border: "1px solid ".concat(palette.shades[300])
  },
  fileStripLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    minWidth: 0
  },
  fileName: {
    fontSize: '13px',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '320px',
    fontFamily: palette.fontFamilies.poppins,
    color: palette.shades[800]
  },
  extractedChip: {
    backgroundColor: pillGreen,
    color: pillGreenText,
    fontSize: '11px',
    fontWeight: 600,
    height: '22px',
    border: "1px solid #A5D6A7"
  },
  intro: {
    fontSize: '13px',
    color: palette.shades[800],
    marginBottom: '14px',
    lineHeight: 1.5,
    fontFamily: palette.fontFamilies.poppins
  },
  introMuted: {
    fontSize: '12px',
    color: palette.shades[600],
    marginTop: '6px'
  },
  summaryCard: {
    backgroundColor: palette.common.white,
    borderRadius: '6px',
    padding: '18px 16px',
    marginBottom: '16px',
    border: "1px solid ".concat(palette.shades[300])
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '14px'
  },
  summaryHeaderDivider: {
    height: '1px',
    backgroundColor: palette.shades[300],
    marginBottom: '14px',
    marginLeft: '-16px',
    marginRight: '-16px'
  },
  extractedEditButton: {
    width: '32px',
    height: '32px',
    padding: 0,
    flexShrink: 0,
    border: 'none',
    borderRadius: '2px',
    backgroundColor: palette.shades[200],
    color: editIconColor,
    cursor: 'not-allowed',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:disabled': {
      opacity: 1
    },
    '& svg': {
      color: 'inherit'
    }
  },
  cardTitle: {
    fontSize: '15px',
    fontWeight: 600,
    fontFamily: palette.fontFamilies.poppins,
    color: palette.shades[800]
  },
  summaryList: {
    listStyle: 'none',
    margin: 0,
    padding: 0
  },
  summaryListGroupGap: {
    marginTop: '22px'
  },
  summaryListItem: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: '8px 12px',
    marginBottom: '6px',
    fontSize: '13px',
    lineHeight: 1.45,
    paddingLeft: '14px',
    position: 'relative',
    fontFamily: palette.fontFamilies.poppins,
    '&::before': {
      content: '"•"',
      position: 'absolute',
      left: 0,
      color: palette.shades[600],
      fontWeight: 700
    },
    '&:last-child': {
      marginBottom: 0
    }
  },
  summaryLabel: {
    color: palette.shades[700],
    fontWeight: 600,
    minWidth: '108px',
    flexShrink: 0
  },
  summaryValue: {
    color: palette.shades[900],
    flex: 1,
    minWidth: 0
  },
  summaryValuePlain: {
    color: editIconColor,
    fontWeight: 500,
    flex: 1,
    minWidth: 0
  },
  pill: {
    backgroundColor: pillGreen,
    color: pillGreenText,
    padding: '4px 10px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: 600,
    display: 'inline-block',
    lineHeight: 1.35
  },
  utilityChips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px'
  },
  utilityChip: {
    backgroundColor: pillGreen,
    color: pillGreenText,
    fontWeight: 600,
    fontSize: '12px',
    height: '26px'
  },
  propertyPills: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    flex: 1,
    minWidth: 0
  },
  propertyPill: {
    backgroundColor: pillGreen,
    color: pillGreenText,
    fontWeight: 600,
    fontSize: '12px',
    maxWidth: '100%',
    height: 'auto',
    minHeight: '26px',
    paddingTop: '4px',
    paddingBottom: '4px',
    '& .MuiChip-label': {
      whiteSpace: 'normal',
      lineHeight: 1.35
    }
  },
  verifyBox: {
    marginTop: '16px',
    padding: '12px 14px',
    borderRadius: '6px',
    backgroundColor: pillGreen,
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start'
  },
  verifyBoxWarning: {
    backgroundColor: '#FFF8E1',
    borderColor: '#FFE082'
  },
  verifyTitle: {
    fontSize: '14px',
    fontWeight: 700,
    color: pillGreenText,
    fontFamily: palette.fontFamilies.poppins
  },
  verifyTitleWarn: {
    color: '#F57F17'
  },
  verifyBody: {
    fontSize: '12px',
    marginTop: '4px',
    lineHeight: 1.45,
    fontFamily: palette.fontFamilies.poppins
  },
  verifyBodyVerified: {
    color: pillGreenText,
    fontWeight: 400
  },
  verifyBodyWarning: {
    color: palette.shades[800]
  },
  notes: {
    fontSize: '12px',
    color: palette.shades[700],
    marginTop: '12px',
    lineHeight: 1.5
  },
  sectionHeading: {
    color: palette.shades[800],
    fontSize: '13px',
    fontWeight: 600,
    marginBottom: '12px',
    marginTop: '4px',
    fontFamily: palette.fontFamilies.poppins,
    lineHeight: 1.5
  },
  propertyCard: {
    backgroundColor: palette.common.white,
    borderRadius: '6px',
    padding: '16px',
    marginBottom: '8px',
    border: "1px solid ".concat(palette.shades[300])
  },
  lineItemsCardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: '10px'
  },
  lineItemsEditButtonWrap: {
    marginTop: '2px'
  },
  lineItemsCardTitles: {
    flex: 1,
    minWidth: 0
  },
  propertyTitle: {
    fontSize: '15px',
    fontWeight: 600,
    marginBottom: '0px',
    color: palette.shades[800],
    fontFamily: palette.fontFamilies.poppins
  },
  propertyAddress: {
    fontSize: '12px',
    color: palette.shades[600],
    lineHeight: 1.4,
    fontFamily: palette.fontFamilies.poppins
  },
  lineItemsShell: {
    display: 'flex',
    gap: 0,
    minHeight: '120px',
    marginTop: '8px',
    marginBottom: '-16px',
    marginLeft: '-16px',
    marginRight: '-16px',
    borderRadius: '0 0 6px 6px',
    overflow: 'hidden',
    backgroundColor: palette.shades[100],
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  utilityNav: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    width: '52px',
    borderRight: "1px solid ".concat(palette.shades[300]),
    backgroundColor: palette.common.white,
    padding: '8px 0'
  },
  utilityNavBtn: {
    width: '100%',
    minHeight: '48px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    padding: '8px 0',
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: palette.shades[100]
    }
  },
  utilityNavBtnActive: {
    backgroundColor: palette.shades[100],
    '&::after': {
      content: '""',
      position: 'absolute',
      right: 0,
      top: '6px',
      bottom: '6px',
      width: '3px',
      borderRadius: '2px 0 0 2px',
      backgroundColor: tealAccent
    }
  },
  utilityNavIconBox: {
    width: '36px',
    height: '36px',
    borderRadius: '4px',
    border: "1px solid ".concat(palette.shades[200]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette.common.white
  },
  utilityPanel: {
    flex: 1,
    padding: '16px 18px',
    backgroundColor: palette.common.white,
    minWidth: 0
  },
  utilityPanelTitle: {
    fontSize: '14px',
    fontWeight: 700,
    marginBottom: 0,
    color: palette.shades[900],
    fontFamily: palette.fontFamilies.poppins
  },
  lineItemsHeaderDivider: {
    marginTop: '10px',
    marginBottom: '6px',
    height: '1px',
    backgroundColor: palette.shades[300]
  },
  lineItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '16px',
    fontSize: '13px',
    padding: '8px 0',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    fontFamily: palette.fontFamilies.poppins,
    color: palette.shades[800]
  },
  lineItemLabel: {
    flex: 1,
    minWidth: 0,
    paddingRight: '8px'
  },
  lineItemValue: {
    flexShrink: 0,
    textAlign: 'right',
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap'
  },
  lineItemsDivider: {
    height: '1px',
    backgroundColor: palette.shades[300],
    margin: '14px 0 12px'
  },
  lineItemsTotalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: 700,
    fontFamily: palette.fontFamilies.poppins,
    color: palette.shades[900],
    marginTop: '14px'
  },
  lineItemsTotalValue: {
    fontVariantNumeric: 'tabular-nums'
  },
  fallbackLineItemsCard: {
    marginTop: '8px'
  }
});